export function humanOrderNo(orderIdLike) {
  const s = String(orderIdLike ?? "").trim();
  if (!s) return "--------";
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); }
  const u = h >>> 0;
  let n = u % 100000000; if (n === 0) n = 1;
  return String(n).padStart(8, "0");
}
